import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { orderBy } from 'lodash';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel,
    InputGroup, InputRightElement, Icon, IconButton, Center, Select, Checkbox,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, useDisclosure,
    Tabs, TabList, TabPanels, Tab, TabPanel, InputRightAddon,
    Link as ChakraLink,
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css'
import { MdAddCircleOutline, MdEdit, MdDeleteForever, MdFileOpen } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';
import { FaFileExport } from 'react-icons/fa';

import { FormattedDate, FormattedTime } from 'react-intl';
import { withNamespaces } from 'react-i18next';

import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.module.css';

import { SUCCESS_STATUS, FAILED_STATUS, NORMAL_MAX_AGE } from '../../../constants';
import "../../../styles/index.scss";

import { 
    apiLoadListEnterprise, apiLoadAEnterprise, apiCreateNewEnterprise, apiUpdateAEnterprise, apiDeleteAEnterprise,
} from '../../../redux/apis/EnterpriseApis';
import { 
    apiLoadListPatient, apiLoadAPatient, apiCreateNewPatient, apiUpdateAPatient, apiDeleteAPatient, 
    apiExportPatientListToCSV, apiExportPatientListToExcel 
} from '../../../redux/apis/PatientApis';
import { 
    clearAEnterpriseDetail, clearEnterpriseActionStatus, clearPatientActionStatus, clearListPatient, clearAPatientDetail,
    clearPatientListRemoteCSV, clearPatientListRemoteExcel 
} from '../../../redux/actions';
import { 
    getEnterpriseList, getAEnterprise, getEnterpriseActionStatus, getEnterpriseActionMsg, getEnterpriseError,
    getPatientList, getAPatient, getPatientTotalCount, getPatientOffset, getPatientActionStatus, getPatientActionMsg, getPatientError, 
    getPatientListRemoteCSV, getPatientListRemoteExcel 
} from '../../../redux/selectors';
import { displayConfirmAlert, displayConfirmChoiceAlert } from '../../utils';

import NoDataPage from '../../../components/NoData';
import AddEditEnterpriseModal from '../Modals/AddEditEnterpriseModal';
import ImportExcelPatientModal from '../Modals/ImportExcelPatientModal';
import AddEditPatientModal from '../Modals/AddEditPatientModal';
import PatientList from './Patients/PatientList';

function Enterprises(props) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie", "settingCookies"]);
    const [ isAction, setIsAction ] = useState(false);
    const mounted = useRef();
    const t = props.t;

    useEffect(() => {
        if(!mounted.current) {
            if(cookies.loginCookie?.data?.companyDetail?.register_type === "FREE") {
                displayConfirmAlert("Bạn cần nâng cấp gói dịch vụ để sử dụng tính năng này!", () => {
                    setCookie("settingCookies", { data: { selectedSetting: "TAI_KHOAN" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                    props.setSelectedSetting("TAI_KHOAN");
                });
            }
            setIsAction(cookies.loginCookie?.data?.roles === "admin" || cookies.loginCookie?.data?.roles === "super_admin");
            mounted.current = true;
        }
    });

    return (
        <React.Fragment>
            <Tabs variant="soft-rounded" colorScheme='green' p={2}
            >
                <TabList>
                    <Tab textTransform="uppercase">{t("Enterprise")}</Tab>
                    <Tab textTransform="uppercase">{t("Staff")}</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        <EnterpriseList isAction={isAction} {...props}/>
                    </TabPanel>
                    <TabPanel>
                        <EnterprisePatients isAction={isAction} {...props}/>
                    </TabPanel>
                </TabPanels>
            </Tabs>
            <ToastContainer />
        </React.Fragment>
    )
}

function EnterpriseList({ 
    enterpriseList, enterpriseDetail, enterpriseActionStatus, enterpriseActionMsg, enterpriseError, isAction, t, 
    clearAEnterpriseDetail, clearEnterpriseActionStatus,
    apiLoadListEnterprise, apiLoadAEnterprise, apiCreateNewEnterprise, apiUpdateAEnterprise, apiDeleteAEnterprise, 
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const initialRef = useRef(null);
    const [ searchText, setSearchText ] = useState("");
    const [ selectedEnterpriseId, setSelectedEnterpriseId ] = useState(null);
    const [ isSearching, setIsSearching ] = useState(false);

    const addEditEnterpriseImportExcelModal = useDisclosure();
    const mounted = useRef();

    useEffect(() => {
        if(!mounted.current) {
            apiLoadListEnterprise({ company_id: cookies?.loginCookie?.data?.company_id });
            mounted.current = true;
        } else {
            if(enterpriseActionStatus === SUCCESS_STATUS) {
                if(isOpen) {
                    onClose();
                }
                toast.success(enterpriseActionMsg, {
                    position: "bottom-right"
                });
                clearEnterpriseActionStatus();
            } 
            else if(enterpriseActionStatus === FAILED_STATUS) {         
                toast.error(enterpriseError, {
                    position: "bottom-right"
                });
                clearEnterpriseActionStatus();
            }
        }  
    });
   
    useEffect(() => {
        setIsSearching(false);
    }, [enterpriseList]);

    const handleAddNewEnterprise = () => {
        clearAEnterpriseDetail();
        onOpen();
    }

    const handleUpdateAEnterprise = (enterprise_id) => {
        apiLoadAEnterprise({ id: enterprise_id });
    }

    const handleDeleteAEnterprise = (enterprise_id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>
                            Xác nhận <br />Bạn có muốn xoá doanh nghiệp này không?
                        </h1>
                        <div>
                            <button onClick={onClose}>Huỷ</button>
                            <button
                                onClick={() => {
                                    apiDeleteAEnterprise({ 
                                        id: enterprise_id, 
                                        payload: { 
                                            company_id: cookies?.loginCookie?.data?.company_id,  
                                            user_id: cookies?.loginCookie?.data?.id,  
                                            is_active: false 
                                        } 
                                    });
                                    onClose();
                                }}
                                className='yes'
                            >
                                Đồng Ý
                            </button>
                        </div>
                    </div>
                )
            },
            closeOnClickOutside: false
        })
    }

    return (
        <React.Fragment>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} borderBottomWidth="2px" p={2} gap={2} justify="space-between">
                <Button borderRadius={10} colorScheme="orange" isDisabled={!isAction} onClick={handleAddNewEnterprise}>
                    <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px"/>   
                    <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Add")}</Text>
                </Button>

                <InputGroup width={{base: "100%", md: "40%", lg: "40%"}}>
                    <Input placeholder={t("Type_Search_Text")} onChange={(evt) => setSearchText(evt.currentTarget.value)} onKeyUp={(evt) => {
                        if(evt.key === "Enter") {
                            setIsSearching(true);
                            setTimeout(() => {
                                apiLoadListEnterprise({ company_id: cookies?.loginCookie?.data?.company_id, searchText });
                            }, 500);
                        }
                    }}/>
                    <InputRightAddon p={0}>
                        <Button colorScheme='blue' 
                            isLoading={isSearching}
                            loadingText={t("Searching")}
                            onClick={() => {
                                setIsSearching(true);
                                setTimeout(() => {
                                    apiLoadListEnterprise({ company_id: cookies?.loginCookie?.data?.company_id, searchText });
                                }, 500);
                            }
                        }>
                            {t("Search")}
                        </Button>
                    </InputRightAddon>
                </InputGroup>
            </Flex>

            <EnterpriseListItems 
                items={enterpriseList} itemsPerPage={10} onOpen={onOpen} isAction={isAction} t={t}
                handleUpdateAEnterprise={handleUpdateAEnterprise} handleDeleteAEnterprise={handleDeleteAEnterprise} 
                addEditEnterpriseImportExcelModal={addEditEnterpriseImportExcelModal} setSelectedEnterpriseId={setSelectedEnterpriseId}
            />

            {
                !(enterpriseList && enterpriseList.length > 0) &&
                <NoDataPage  text="Hiện tại không có dữ liệu"/>
            }     
            {
                isOpen &&
                <AddEditEnterpriseModal 
                    enterpriseDetail={enterpriseDetail} initialRef={initialRef} isOpen={isOpen} onClose={onClose}  
                    company_id={cookies?.loginCookie?.data?.company_id} actionStatus={enterpriseActionStatus}
                    apiCreateNewEnterprise={apiCreateNewEnterprise} apiUpdateAEnterprise={apiUpdateAEnterprise}
                />
            }
            {
                addEditEnterpriseImportExcelModal.isOpen &&
                <ImportExcelPatientModal 
                    initialRef={initialRef} isOpen={addEditEnterpriseImportExcelModal.isOpen} onClose={addEditEnterpriseImportExcelModal.onClose} 
                    company_id={cookies?.loginCookie?.data?.company_id} enterprise_id={selectedEnterpriseId}
                />
            }
        </React.Fragment>
    )
}

function EnterpriseListItems({ 
    items, itemsPerPage, onOpen, addEditEnterpriseImportExcelModal, setSelectedEnterpriseId, isAction, t,
    handleUpdateAEnterprise, handleDeleteAEnterprise 
}) {
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        setItemOffset(newOffset);
    } 

    return (
        <>
           <TableContainer width="100%" px="20px" py="5px">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr bg="#EAF0F0">
                            <Th>{t("Index")}</Th>  
                            <Th>{t("Name")}</Th>    
                            <Th>{t("Representative")}</Th>
                            <Th>{t("Address")}</Th>
                            <Th>{t("Email")}</Th>
                            <Th>{t("Phone")}</Th>
                            <Th>{t("Staff")}</Th>
                            <Th>{t("Created_At")}</Th>
                            <Th>{t("Edited_At")}</Th>
                            <Th isNumeric></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            currentItems && currentItems.map((item, idx) => (
                                <Tr key={item.id}>
                                    <Td>
                                        <Text fontWeight="600">{itemOffset + idx + 1}</Text>
                                    </Td>
                                    <Td>
                                        <Text fontWeight="600">{item.name}</Text>
                                    </Td>
                                    <Td>
                                        <Text fontWeight="600">{item.representative}</Text>
                                    </Td>
                                    <Td>
                                        <Text fontWeight="600">{item.address}</Text>
                                    </Td>
                                    <Td>
                                        <Text fontWeight="600">{item.email}</Text>
                                    </Td>
                                    <Td>
                                        <Text fontWeight="600">{item.phone}</Text>
                                    </Td>
                                    <Td>
                                        <Text fontWeight="600">{item.patientTotalCount}</Text>
                                    </Td>
                                    <Td>
                                        <Text fontWeight="600">
                                            <FormattedDate value={item.created_at} /> <FormattedTime value={item.created_at} />
                                        </Text>
                                    </Td>
                                    <Td>
                                        {
                                            item.updated_at &&
                                            <Text fontWeight="600">
                                                <FormattedDate value={item.updated_at} /> <FormattedTime value={item.updated_at} />
                                            </Text>
                                        }
                                    </Td>
                                    <Td isNumeric>
                                        <Flex direction="row" justifyContent="flex-end" alignContent="center" gap={1}>
                                            <Button colorScheme='teal' mr={3} type='submit' isDisabled={!isAction}  
                                                onClick={() => {
                                                        addEditEnterpriseImportExcelModal.onOpen();
                                                        setSelectedEnterpriseId(item.id);
                                                    }
                                                }
                                            >
                                                <Icon boxSize={6} as={MdFileOpen} marginRight="8px"/> 
                                                <Text fontSize="14px">{t("Import_Data_From_File")}</Text>
                                            </Button>
                                            <IconButton
                                                title='Sửa'
                                                colorScheme='blackAlpha'
                                                icon={<MdEdit />}
                                                isDisabled={!isAction}
                                                onClick={() => {
                                                        onOpen();
                                                        handleUpdateAEnterprise(item.id);
                                                    }
                                                }
                                            />
                                            <IconButton
                                                colorScheme='red'
                                                title='Xoá'
                                                icon={<MdDeleteForever />}
                                                isDisabled={!isAction}
                                                onClick={() => handleDeleteAEnterprise(item.id)}
                                            />
                                        </Flex>
                                    </Td>
                                </Tr>
                            ))
                        }
                    </Tbody>
                </Table>
            </TableContainer>

           {/* <Flex w="100%" justify="center" my="10px" position={{base: "relative", md: "fixed", lg: "fixed"}} bottom="0px"> */}
                <ReactPaginate 
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowLeftCircle} />
                        </Center>
                    }
                    nextLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowRightCircle} />
                        </Center>
                    }
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageClassName='page-item'
                    activeClassName='active'
                    previousClassName='previous-item'
                    nextClassName='next-item'
                />
            {/* </Flex> */}
        </>
    )
}

function EnterprisePatients({ 
    enterpriseList, patientList, patientDetail, patientOffset, patientTotalCount, patientActionStatus, patientActionMsg, patientError, 
    isAction, clearAPatientDetail, remoteCSV, remoteExcel, t,
    apiLoadListPatient, apiLoadAPatient, apiCreateNewPatient, apiUpdateAPatient, apiDeleteAPatient, clearPatientActionStatus, clearListPatient,
    apiExportPatientListToCSV, apiExportPatientListToExcel, clearPatientListRemoteCSV, clearPatientListRemoteExcel   
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const [ exportFileType, setExportFileType ] = useState("EXCEL");
    const [ searchText, setSearchText ] = useState(null);
    const [ selectedEnterpriseId, setSelectedEnterpriseId ] = useState(0);
    const [ selectedEnterpriseName, setSelectedEnterpriseName ] = useState(null);
    const [ fromDate, setFromDate ] = useState(new Date());
    const [ toDate, setToDate ] = useState(new Date());

    const [ isSearching, setIsSearching ] = useState(false);
    const [ isAttachedPatientResult, setIsAttachedPatientResult ] = useState(false);
    const [ isShowCircularProgress, setIsShowCircularProgress ] = useState(false);
    
    const addEditPatientModal = useDisclosure();
    const mounted = useRef();

    const limit = 10;
    const pageCount = Math.ceil(patientTotalCount / limit);
    const itemsPerPage = limit;

    enterpriseList = orderBy(enterpriseList, ["name"]);

    useEffect(() => {
        if(!mounted.current) {
            clearListPatient();
            mounted.current = true;
        } else {
            if(patientActionStatus === SUCCESS_STATUS) {
                if(addEditPatientModal.isOpen) {
                    addEditPatientModal.onClose();
                }
                toast.success(patientActionMsg, {
                    position: "bottom-right"
                });
                clearPatientActionStatus();
            } 
            else if(patientActionStatus === FAILED_STATUS) {         
                toast.error(patientError, {
                    position: "bottom-right"
                });
                clearPatientActionStatus();
            }
        }
    });

    useEffect(() => {
        setIsSearching(false);
        setIsShowCircularProgress(false);
    }, [patientList]);

    useEffect(() => {
        if (remoteCSV){
            const blobCSV = new Blob([remoteCSV], {type: 'text/csv;charset=UTF-16'});
            //Build a URL from the file
            const fileURL = window.URL.createObjectURL(blobCSV);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute("download", `${selectedEnterpriseName}_KQK.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            clearPatientListRemoteCSV();
        }
    }, [remoteCSV]);

    useEffect(() => {
        if (remoteExcel){
            const blobEXCEL = new Blob([remoteExcel], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'});
            //Build a URL from the file
            const fileURL = window.URL.createObjectURL(blobEXCEL);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute("download", `${selectedEnterpriseName}_KQK.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            clearPatientListRemoteExcel();
        }
    }, [remoteExcel]);

    const handleChangeEnterprise = async(enterprise_id) => {
        const firstEnterprise = enterpriseList.find(item => item.id === parseFloat(enterprise_id));
        setSelectedEnterpriseName(firstEnterprise?.name);

        setIsShowCircularProgress(true);
        setTimeout(() => {
            setSelectedEnterpriseId(enterprise_id);

            apiLoadListPatient({ 
                company_id: cookies?.loginCookie?.data?.company_id, 
                enterprise_id: enterprise_id ? enterprise_id : -1, 
                limit: itemsPerPage, 
                offset: 0 
            });
        }, 500);
    }

    const handleAddNewPatient = () => {
        clearAPatientDetail();
        addEditPatientModal.onOpen();
    }

    const handleExportFile = () => {
        displayConfirmChoiceAlert(`Bạn có muốn xuất dữ liệu ra file ${exportFileType}`, () => {
            if(exportFileType === "CSV") {
                apiExportPatientListToCSV({ 
                    company_id: cookies?.loginCookie?.data?.company_id, 
                    enterprise_id: selectedEnterpriseId,
                    user_id: cookies?.loginCookie?.data?.id,    
                });
            } else if(exportFileType === "EXCEL") {
                apiExportPatientListToExcel({ 
                    company_id: cookies?.loginCookie?.data?.company_id, 
                    enterprise_id: selectedEnterpriseId,
                    isAttachedPatientResult,
                    fromDate, 
                    toDate,
                    user_id: cookies?.loginCookie?.data?.id,   
                });
            } 
        })
    }

    return (
        <React.Fragment>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} px={4} py={2} gap={2} justify="space-between">
                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} gap={4}>
                    <Select value={selectedEnterpriseId} placeholder={t("Select_Enterprise")}
                        onChange={(evt) => handleChangeEnterprise(evt.target.value)} 
                    >
                        {
                            enterpriseList && enterpriseList.map(item => (
                                <React.Fragment key={item.id}>
                                    <option value={item.id}>{item.name}</option>
                                </React.Fragment>
                            ))
                        }
                    </Select>

                    <Button colorScheme='orange' minW="120px" isDisabled={selectedEnterpriseId <= 0 || !isAction}
                        onClick={handleAddNewPatient}
                    >
                        <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px"/>   
                        <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Add")}</Text>
                    </Button>

                    <InputGroup>
                        <Button paddingRight={1} borderTopRightRadius={0} borderBottomRightRadius={0} isDisabled={selectedEnterpriseId <= 0 || !isAction}
                                onClick={() => handleExportFile()}
                        >
                            <Icon boxSize={6} as={FaFileExport} marginRight="8px"/>  
                            <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Export_File")}</Text>
                        </Button>
                        <InputRightAddon p={0}>
                            <Select value={exportFileType} borderTopLeftRadius={0} borderBottomLeftRadius={0} isDisabled={selectedEnterpriseId <= 0 || !isAction}
                                onChange={(evt) => setExportFileType(evt.currentTarget.value)}
                            >
                                <option value="EXCEL">EXCEL</option>
                                <option value="CSV">CSV</option>
                            </Select>
                        </InputRightAddon>
                    </InputGroup>
                </Flex>

                <InputGroup maxW="400px">
                    <Input placeholder={t("Type_Search_Text")} onChange={(evt) => setSearchText(evt.currentTarget.value)} onKeyUp={(evt) => {
                        if(evt.key === "Enter" && (selectedEnterpriseId > 0)) {
                            setIsSearching(true);
                         
                            setTimeout(() => {
                                apiLoadListPatient({ 
                                    company_id: cookies?.loginCookie?.data?.company_id, 
                                    enterprise_id: selectedEnterpriseId, searchText 
                                });
                            }, 500);
                        }
                    }}/>
                    <InputRightAddon p={0}>
                        <Button colorScheme='blue' isDisabled={selectedEnterpriseId <= 0}
                            isLoading={isSearching}
                            loadingText={t("Searching")}
                            onClick={() => {
                                setIsSearching(true);
                                setTimeout(() => {
                                    apiLoadListPatient({ 
                                        company_id: cookies?.loginCookie?.data?.company_id, 
                                        enterprise_id: selectedEnterpriseId, searchText 
                                    });
                                }, 500);
                            }
                        }>
                            {t("Search")}
                        </Button>
                    </InputRightAddon>
                </InputGroup>
            </Flex>

            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} p={2} gap={4} align="center">
                <Checkbox colorScheme='orange' minW="100px" isChecked={isAttachedPatientResult} isDisabled={selectedEnterpriseId <= 0 || !isAction}
                    onChange={() => setIsAttachedPatientResult(!isAttachedPatientResult)}
                >
                    {t("Export_File_Attached_Result")}
                </Checkbox>

                <Text ml={8}>{t("From_Date")}</Text>
                <DatePicker dateFormat="dd/MM/yyyy" selected={fromDate} disabled={!isAttachedPatientResult}
                    onChange={
                        (date) => setFromDate(date)
                    }
                    showIcon
                    placeholderText="Ngày đặt hẹn"
                    className='date-picker'
                />

                <Text ml={4}>{t("To_Date")}</Text>
                <DatePicker dateFormat="dd/MM/yyyy" selected={toDate} disabled={!isAttachedPatientResult}
                    onChange={
                        (date) => setToDate(date)
                    }
                    showIcon
                    placeholderText="Ngày đặt hẹn"
                    className='date-picker'
                />
            </Flex>

            <PatientList 
                items={patientList} itemsPerPage={limit} itemOffset={patientOffset} pageCount={pageCount} 
                isAction={isAction} t={t}
                patientDetail={patientDetail} addEditPatientModal={addEditPatientModal}
                apiLoadListPatient={apiLoadListPatient} apiLoadAPatient={apiLoadAPatient} apiDeleteAPatient={apiDeleteAPatient}                       
            />

            {
                !(patientList && patientList.length > 0) &&
                <NoDataPage text="Hiện tại không có dữ liệu"/>
            }

            {
                addEditPatientModal.isOpen &&
                <AddEditPatientModal 
                    isOpen={addEditPatientModal.isOpen} onClose={addEditPatientModal.onClose} 
                    company_id={cookies?.loginCookie?.data?.company_id} enterprise_id={selectedEnterpriseId} 
                    patientDetail={patientDetail} enterpriseList={enterpriseList} actionStatus={patientActionStatus} 
                    apiCreateNewPatient={apiCreateNewPatient} apiUpdateAPatient={apiUpdateAPatient}
                />
            }

            {
                isShowCircularProgress &&
                <Center>
                    <CircularProgress position="fixed" top="20vh" isIndeterminate size="200px" zIndex={9999}>
                        <CircularProgressLabel fontSize="24px" fontWeight="700" color="#2196f3">{t("Loading")}</CircularProgressLabel>
                    </CircularProgress>
                </Center>
            }
        </React.Fragment>
    )     
}

const mapStateToProps = (state) => {
    const enterpriseList           =   getEnterpriseList(state);
    const enterpriseDetail         =   getAEnterprise(state);
    const enterpriseActionStatus   =   getEnterpriseActionStatus(state);
    const enterpriseActionMsg      =   getEnterpriseActionMsg(state);
    const enterpriseError          =   getEnterpriseError(state);

    const patientList              =   getPatientList(state);
    const patientDetail            =   getAPatient(state);
    const patientTotalCount        =   getPatientTotalCount(state);
    const patientOffset            =   getPatientOffset(state);
    const patientActionStatus      =   getPatientActionStatus(state);
    const patientActionMsg         =   getPatientActionMsg(state);
    const patientError             =   getPatientError(state);

    const remoteCSV                =   getPatientListRemoteCSV(state);
    const remoteExcel              =   getPatientListRemoteExcel(state);

    return { 
        enterpriseList, enterpriseDetail, enterpriseActionStatus, enterpriseActionMsg, enterpriseError,
        patientList, patientDetail, patientTotalCount, patientOffset, patientActionStatus, patientActionMsg, patientError, remoteCSV, remoteExcel
    };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListEnterprise:        payload => dispatch(apiLoadListEnterprise(payload)),
    apiLoadAEnterprise:           payload => dispatch(apiLoadAEnterprise(payload)),
    apiCreateNewEnterprise:       payload => dispatch(apiCreateNewEnterprise(payload)),
    apiUpdateAEnterprise:         payload => dispatch(apiUpdateAEnterprise(payload)),
    apiDeleteAEnterprise:         payload => dispatch(apiDeleteAEnterprise(payload)),

    apiLoadListPatient:           payload => dispatch(apiLoadListPatient(payload)),
    apiLoadAPatient:              payload => dispatch(apiLoadAPatient(payload)),
    apiCreateNewPatient:          payload => dispatch(apiCreateNewPatient(payload)),
    apiUpdateAPatient:            payload => dispatch(apiUpdateAPatient(payload)),
    apiDeleteAPatient:            payload => dispatch(apiDeleteAPatient(payload)),

    apiExportPatientListToCSV:    payload => dispatch(apiExportPatientListToCSV(payload)),
    apiExportPatientListToExcel:  payload => dispatch(apiExportPatientListToExcel(payload)),

    clearListPatient:             payload => dispatch(clearListPatient(payload)),
    clearAEnterpriseDetail:       payload => dispatch(clearAEnterpriseDetail(payload)),
    clearEnterpriseActionStatus:  payload => dispatch(clearEnterpriseActionStatus(payload)),
    clearAPatientDetail:          payload => dispatch(clearAPatientDetail(payload)),
    clearPatientActionStatus:     payload => dispatch(clearPatientActionStatus(payload)),
    clearPatientListRemoteCSV:    payload => dispatch(clearPatientListRemoteCSV(payload)),
    clearPatientListRemoteExcel:  payload => dispatch(clearPatientListRemoteExcel(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Enterprises));